module.exports = __webpack_public_path__ + "9fb2d13f9c455eece130c9e06179be69.svg";